export default __webpack_public_path__ + "static/media/svg1.7bcafce3.svg";